"use client"

import { useInView } from "react-intersection-observer"
import { HeartHandshake, Users, HelpingHand } from "lucide-react"
import "../assets/css/people.css"
import PeopleImage from "../assets/images/people.jpg"

export default function PeopleEmpowering() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  })

  return (
    <section id="people-empowering" ref={ref} className="people-section">
      <div className="people-container">
        <div className="section-header">
          <h2 className={`section-title ${inView ? "visible" : ""}`}>People Empowering & Unity</h2>
          <div className={`section-divider ${inView ? "visible" : ""}`}></div>
          <p className={`people-subtitle ${inView ? "visible" : ""}`}>
            Empowering Individuals, Serving Society, Uniting People
          </p>
        </div>

        <div className="people-grid">
          <div className={`people-content ${inView ? "visible" : ""}`}>
            <h3 className="people-title2">Our Social Commitment</h3>
            <p className="people-description">
              We believe in the power of people. Our initiatives focus on empowering individuals, fostering unity, and uplifting communities through dedicated social service.
            </p>
            <div className="people-features">
              <div className="people-feature">
                <div className="people-feature-icon">
                  <HeartHandshake className="icon-svg" />
                </div>
                <div className="people-feature-content">
                  <h4 className="people-feature-title">Empowering People</h4>
                  <p className="people-feature-description">
                    Providing opportunities and resources for personal and professional growth.
                  </p>
                </div>
              </div>
              <div className="people-feature">
                <div className="people-feature-icon">
                  <HelpingHand className="icon-svg" />
                </div>
                <div className="people-feature-content">
                  <h4 className="people-feature-title">Social Service</h4>
                  <p className="people-feature-description">
                    Engaging in meaningful social work to support and uplift those in need.
                  </p>
                </div>
              </div>
              <div className="people-feature">
                <div className="people-feature-icon">
                  <Users className="icon-svg" />
                </div>
                <div className="people-feature-content">
                  <h4 className="people-feature-title">People Unity</h4>
                  <p className="people-feature-description">
                    Bringing people together to build a stronger, more united community.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={`people-image-container ${inView ? "visible" : ""}`}>
            <div className="people-image">
              <img src={PeopleImage} alt="People Unity" className="image-people" />
              <div className="image-overlay">
                {/* <div className="overlay-content">
                  <p className="overlay-quote">"Together, we rise."</p>
                  <p className="overlay-author">– Community First</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
